import config from "../config";
let _default_hostname = config.default_hostname || window.location.hostname;
let _default_port = config.default_port || "3030";

export default function (
  state = {
    connection: {
      protocol: _default_hostname.includes("localhost")
        ? "http://"
        : "https://",
      hostname: _default_hostname,
      host: _default_hostname + ":" + _default_port,
    },
    setup_mode: false,
    config_data: { need_restart: false, system_restarting: false },
    alarm_data: {
      system_armed: false,
      intrusion_module_id: false,
      arm_countdown: false,
    },
    alarm_log: [],
    mqtt_log: [],
    config_db: {},
    config_validation: {},
    alarm_select: {},
    device_name: "",
    event_action: {},
    controllers_state: {},
    modules_state: {},
    loading: false,
    remote_command: { type: {}, params: {} },
    component_info: {},
    refresh: false,
    pulse: false,
    error: "",
  },
  action
) {
  switch (action.type) {
    case "LOADING_START":
      state.loading = true;
      return { ...state };
    case "LOADING_STOP":
      state.loading = false;
      return { ...state };
    case "DEVICE_PULSE":
      state.pulse = !state.pulse;
      state.event_action = action.event_action;
      state.modules_state = action.data.modules_state;
      state.server_time = action.server_time;
      state.config_data = action.data.config_data;
      state.alarm_data = action.data.alarm_data;
      state.device_name = action.data.device_name;
      state.controllers_online = action.data.controllers_online;
      //mini log
      if (
        state.event_action.type === "ALARM_ARM" ||
        state.event_action.type === "ALARM_DISARM"
      ) {
        state.refresh = !state.refresh;
      }
      return { ...state };
    case "DEVICE_EVENT":
      state.event_action = action.event_action;
      state.modules_state = action.data.modules_state;
      state.server_time = action.server_time;
      state.config_data = action.data.config_data;
      state.alarm_data = action.data.alarm_data;
      state.device_name = action.data.device_name;
      state.controllers_online = action.data.controllers_online;
      //mini log
      if (
        state.event_action.type === "ALARM_ARM" ||
        state.event_action.type === "ALARM_DISARM"
      ) {
        state.refresh = !state.refresh;
      }
      return { ...state };
    case "MQTT_MESSAGE":
      let log = {
        time: action.data.server_time,
        mqtt_message: JSON.stringify(action.data.mqtt_message),
      };
      state.mqtt_log.unshift(log);
      let log_length = state.mqtt_log.length;
      if (log_length > 100) {
        state.mqtt_log.splice(100, log_length - 100);
      }
      state.refresh = !state.refresh;
      return { ...state };
    case "CLEAR_MQTT_LOG":
      state.mqtt_log = [];
      return { ...state };
    case "ALARM_EVENT":
      if (action.event_action === "ALARM_EVENT") {
        console.log("ALARM_EVENT");
        console.log(action.data);
        let log_state = action.data;
        let log = {
          time: action.server_time,
          type: state.event_action.type,
          area_name: log_state.area_name,
          module_name: log_state.module_name,
          component_id: log_state.component_id,
          class_prop: log_state.class_prop,
          state: log_state.state.msg,
        };
        state.alarm_log.unshift(log);
        let log_length = state.alarm_log.length;
        if (log_length > 100) {
          state.alarm_log.splice(100, log_length - 100);
        }
      }
      state.refresh = !state.refresh;
      return { ...state };
    case "CONFIG_UPDATE_FORM":
      state.config_db[action.field] = action.value;
      if (state.config_validation[action.field]) {
        state.config_validation[action.field] = {};
      }
      return { ...state };
    case "CONFIG_DETAILS":
      state.config_db = action.data;
      return { ...state };
    case "CONFIG_VALIDATION_ERROR":
      state.config_validation = action.data;
      return { ...state };
    case "ALARM_SELECT":
      state.alarm_select = action.data;
      return { ...state };

    case "LOGGED_IN":
      state.config_data = action.data.config_data;
      return { ...state };

    case "HOSTNAME_UPDATE":
      state.connection.hostname = action.hostname;
      state.connection.protocol = action.hostname.includes("localhost")
        ? "http://"
        : "https://";
      state.connection.host = action.hostname + ":3030";
      return { ...state };

    case "MODULES_STATE":
      state.modules_state = action.data;
      return { ...state };
    case "ALARM_LOG":
      state.alarm_log = action.data;
      return { ...state };
    case "COMPONENT_EVENT":
      state.modules_state = action.data;
      return { ...state };
    case "MODULE_COMMAND":
      state.remote_command = action.remote_command;
      return { ...state };
    case "REMOTE_COMMAND":
      if (action.data.remote_command === "component_info") {
        state.component_info = action.data.data;
      }
      return { ...state };
    case "CLEAR_COMPONENT_INFO":
      state.component_info = {};
      return { ...state };
    case "SYSTEM_COMMAND":
      state.remote_command = action.remote_command;
      return { ...state };
    case "SYSTEM_RESTART":
      state.remote_command = action.remote_command;
      state.config_data.system_restarting = true;
      return { ...state };
    case "SET_SETUP_MODE":
      state.setup_mode = true;
      return { ...state };
    case "UNSET_SETUP_MODE":
      state.setup_mode = false;
      return { ...state };
    default:
      break;
  }
  return state;
}
